/* global axios */
import ApiClient from './ApiClient';

class VoipAPI extends ApiClient {
  constructor() {
    super('voip', { accountScoped: true });
  }

  initiate({ contactId, opportunityId, ramal }) {
    return axios.post(`${this.url}/initiate`, {
      contact_id: contactId,
      opportunity_id: opportunityId,
      ramal,
    });
  }

  hangup(callId) {
    return axios.post(`${this.url}/hangup`, { call_id: callId });
  }

  getExtensions() {
    return axios.get(`${this.url}/extensions`);
  }

  getCallHistory(params = {}) {
    return axios.get(`${this.url}/call_history`, { params });
  }
}

export default new VoipAPI();
